import { useRouteMatch } from 'react-router-dom'

export function build(url, path) {
  const [, country] = url.split('/')

  return path.charAt(0) === '/' ? `/${country}${path}` : `/${country}/${path}`
}

export default function useRouteBuilder() {
  const { url } = useRouteMatch()

  function buildRoute(path) {
    return build(url, path)
  }

  return { buildRoute }
}
